exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-container[data-v-5816e090]{width:6em;height:6em}.circle[data-v-5816e090]{width:5em;height:5em}.circle-container .label[data-v-5816e090]{line-height:10px}", ""]);

// exports
